<!-- src/app/pages/cost-metrics/cost-metrics.component.html -->
<div class="costMetricsComponent">
    <p-tabs [(value)]="activeTab" (valueChange)="onTabChange($event)" class="metricParent">
        <p-tablist>
            <p-tab value="0">Cost Savings</p-tab>
            <p-tab value="1">Cost Analysis</p-tab>
            <p-tab value="2">Net Benefits</p-tab>
        </p-tablist>

        <div class="commonMetrics">
            <p>
                Comparison of base scenario with
                <!-- src/app/pages/cost-metrics/cost-metrics.component.html -->
                <p-select [options]="simulationOptions" [(ngModel)]="currentSimulationId" (ngModelChange)="onCurrentSimulationChange($event)" [placeholder]="'Select simulation'"> </p-select>
                against Base scenario for a period of
                <p-select [options]="yearOptions" [(ngModel)]="yearSelected" (ngModelChange)="onRangeChange($event)" optionLabel="label" optionValue="value" placeholder="Select Years"> </p-select>
            </p>
        </div>

        <p-tabpanels>
            <p-tabpanel value="1">
                @if (activeTab === '1') {
                    <app-cost-analysis [baseCm]="baseCm" [currentCm]="currentCm" [range]="yearSelected" [yearKey]="yearKey" [refreshKey]="activeTab"> </app-cost-analysis>
                }
            </p-tabpanel>

            <p-tabpanel value="0">
                <app-cost-savings [baseCm]="baseCm" [currentCm]="currentCm" [range]="yearSelected" [yearKey]="yearKey" [currentRunId]="currentSimulationId"> </app-cost-savings>
            </p-tabpanel>

            <p-tabpanel value="2">
                <app-net-benefit [baseCm]="baseCm" [currentCm]="currentCm" [range]="yearSelected" [yearKey]="yearKey" [hasComparison]="hasComparison"> </app-net-benefit>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>
